module.exports = (function() {
  const accordions = document.querySelectorAll('.accordion');

  for(var i=0;i<accordions.length;i++) {
    initAccordion(accordions[i]);
  }

  function initAccordion(accordion) {
    const title = accordion.querySelector('.accordion__title');
    const content = accordion.querySelector('.accordion__content');

    content.dataset.originalHeight = content.getBoundingClientRect().height;
    content.style.height = '0px';

    accordion.classList.toggle('is-active', false);

    title.addEventListener('click', () => {
      const isClosed = content.style.height === '0px';
      content.style.height = isClosed ? `` : '0px';
      accordion.classList.toggle('is-active', isClosed);
    })
  }
})()


// WEBPACK FOOTER //
// ./resources/assets/js/accordion.js